<script>
import Vue from "vue";
import store from "./store";

import VueLazyload from "vue-lazyload";

import { mapState, mapGetters, mapMutations } from "vuex";


import Slick from "./vue-components/slick";
import TaxonomySelect from "./vue-components/taxonomy-select";
import PhotoGallery from "./vue-components/photo-gallery";
import CardFeed from "./vue-components/card-feed";
import CardFeedReset from "./vue-components/card-feed-reset";
import MemberFilter from "./vue-components/member-filter";
import MemberList from "./vue-components/member-list";
import MarketDataTabs from "./vue-components/market-data-tabs";
import MarketDataChart from "./vue-components/market-data-chart";
import MarketDataWorldwide from "./vue-components/market-data-worldwide";
import FobPriceComparison from "./vue-components/fob-price-comparison";
import DataDownloadButton from "./vue-components/data-download-button";
import MLCardFeed from "./vue-components/ml-card-feed";

Vue.config.productionTip = false;

Vue.use(VueLazyload, { preLoad: 1.5 });

new Vue({
    el: "#page",
    store,
    components: {
        slick: Slick,
        "photo-gallery": PhotoGallery,
        "taxonomy-select": TaxonomySelect,
        "card-feed": CardFeed,
        "card-feed-reset": CardFeedReset,
        "member-filter": MemberFilter,
        "member-list": MemberList,
        "market-data-tabs": MarketDataTabs,
        "market-data-chart": MarketDataChart,
        "market-data-worldwide": MarketDataWorldwide,
        "fob-price-comparison": FobPriceComparison,
        "data-download-button": DataDownloadButton,
        "ml-card-feed": MLCardFeed,
    },
    computed: {
        ...mapState([
            "marketDataIsLoading",
            "marketDataSettings",
            "isDesktop",
            "urlHashFilter"
        ]),
        ...mapGetters(["topTenMarkets"])
    },
    watch: {
        urlHashFilter() {
            let hashItems = [];
            Object.keys(this.urlHashFilter).map((key, index) => {
                const filterParam = this.urlHashFilter[key];
                if (filterParam) {
                    hashItems.push(`${key}=${filterParam}`);
                }
            });

            if (hashItems.length) {
                window.location.hash = hashItems.join("&");
            } else {
                // clear hash
                // the '#/' prevents the page from jumping back to the top
                window.location.hash = "/";
            }
        }
    },
    methods: {
        ...mapMutations(["updateIsDesktop"]),
        checkViewport() {
            // 1200px is the 'desktop' breakpoint used in our tailwind.js config.
            if (
                window.matchMedia &&
                window.matchMedia("(min-width: 1200px)").matches
            ) {
                this.updateIsDesktop(true);
            } else {
                this.updateIsDesktop(false);
            }
        }
    },
    created() {
        this.checkViewport();

        window.addEventListener("resize", this.checkViewport);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkViewport);
    }
});
</script>



// WEBPACK FOOTER //
// src/js/app.vue